module.exports = __webpack_public_path__ + "img/delete-patient-custom-list.316e5e85.png";